const MIXIN_FORM_FILTER = {
  methods: {
    onSubmit (data) {
      this.$emit('request', data)
    },
    onReset () {
      this.$emit('reset')
    }
  }
}

export {
  MIXIN_FORM_FILTER
}
